import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDsoRegionList } from '../../../../../../../../../actions/dsosActions';
import { createLoadingSelector } from '../../../../../../../../../apis/selectors';

const actions = ['FETCH_DSO_REGION_LIST', 'GET_GROUP_REGIONS_AND_OFFICES'];
const loadingSelector = createLoadingSelector(actions);

export const useRegionsCard = (dsoId) => {
  const dispatch = useDispatch();
  const {
    filters,
    data,
    total,
    isActiveRequest,
    isFinalPage,
    dsoId: stateDsoId,
  } = useSelector((state) => state.dsos.orgStructure.regionList);
  const isLoading = useSelector((state) => loadingSelector(state));

  const handleScrollList = useCallback(
    (event) => {
      const { scrollHeight, scrollTop, clientHeight } = event.target;
      const tableScrollHeight = scrollHeight - scrollTop - 20;
      if (tableScrollHeight <= clientHeight && !isActiveRequest && !isFinalPage) {
        dispatch(
          fetchDsoRegionList(dsoId, {
            page: filters.page + 1,
            limit: 100,
            orderBy: filters.orderBy,
          }),
        );
      }
    },
    [dispatch, filters.page, isActiveRequest, isFinalPage, dsoId, filters.orderBy],
  );

  useEffect(() => {
    dispatch(fetchDsoRegionList(dsoId, { page: 1, limit: 100 }));
  }, [dispatch, dsoId]);

  return {
    data: stateDsoId === dsoId ? data : [],
    total,
    limit: filters.limit,
    isInitialLoading: !data.length && isLoading,
    isLoading: isActiveRequest,
    handleScrollList,
  };
};
